<template>
<div v-if="!isMobile()" class="modal-card" style="text-align: -webkit-center;">
    <header class="modal-card-head">
        <div class="model-icon icon-watchlist">
            <img src="/img/noun_Eye_2037671.svg">
        </div>
        <button
            type="button"
            class="delete"
            @click="$parent.close()"
        />
    </header>
    <section class="modal-card-body">
        <div class="card-content">
            <div class="has-text-weight-bold is-size-4-tablet is-size-5-mobile">Edit Watchlist name</div>
            <input v-model="name" placeholder="Active" type="text" maxlength="40" class="m-t-40 m-b-40 w-100 px-2"/>
            <div>
                <a class="button is-primary" @click="updateWatchlist">Update</a>
            </div>
        </div>
    </section>
</div>
<div v-else class="modal-card h-100">
    <header class="modal-card-head">
        <a class="btn-close" @click="$parent.close()">
            <b-icon  icon="close" size="is-medium" ></b-icon>
        </a>
    </header>
    <section class="modal-card-body">
        <div class="watchlist-head p-2 text-align-center is-uppercase mb-5">
            Edit Watchlist
            <img class="pl-5" src="/img/Watchlist.png">
        </div>
        <div class="card-content">
            <div class="has-text-weight-bold is-size-4-tablet is-size-5-mobile">Edit Watchlist name</div>
            <input v-model="name" placeholder="Active" type="text" maxlength="40"
                   class="m-t-40 m-b-40 w-100 px-2"/>
            <div>
                <a class="button is-primary" @click="updateWatchlist">Update</a>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import compositeMixin from "@/mixins/compositeMixin";
import axios from 'axios';
export default {
    name: "edit-watchlist-modal",
    mixins: [compositeMixin],
    props: {
        id:Number,
        watchListName:String,
        },
    data() {
        return {
            name: '',
        }
    },
    mounted() {
        this.name = this.watchListName
    },
    methods: {
        async updateWatchlist() {
            if(this.name !== '') {
                await axios.put(`/watchlist/${this.id}`, {
                    name: this.name
                }).then((res) => {
                    if(res.status === 200) {
                        this.$toast.success('Watchlist updated successfully!')
                        this.$emit('update:name', this.name)
                        this.$parent.close();
                    }
                    
                }).catch(err => {
                    this.$toast.error(err.response.data.message)
                })
            }
            else {
                this.$toast.error('Watchlist name is empty!')
            }
            
        }
    }
}
</script>

<style>

</style>